import { SonCta } from '../components/cta'
import { Reveal } from '../components/hareket'
import { Baslik, Kart, SayfaUstu, Section } from '../components/ui'
import { useHead } from '../lib/head'

export function Hakkimizda() {
  useHead(
    {
      title: 'Hakkımızda',
      description:
        'Akıllı Dernek, iki derneğin gerçek ihtiyacından doğdu: kongre düzenleyen bir meslek derneği ve eğitim veren bir akademi derneği.',
    },
    '/hakkimizda',
  )
  const ilkeler = [
    {
      b: 'Bitmemiş olan bitmemiş denir',
      m: 'Sitede "yakında" yazan özellik gerçekten sırada; hazır yazan özellik gerçekten çalışıyor. Yol haritası herkese açık.',
    },
    {
      b: 'Veri derneğindir',
      m: 'İstediğiniz an açık biçimde dışa aktarırsınız. Sağlayıcı sözleşmeleri sizin adınıza; para sizin hesabınıza.',
    },
    {
      b: 'Mevzuatı abartmayız',
      m: 'Resmî defter ve alındı belgesi Bakanlık iznine bağlıdır; iznimiz yokken "uyumlu" demeyiz. Kaydı düzenli tutmanıza yardım ederiz.',
    },
    {
      b: 'Sakin ürün',
      m: 'Aidat, üye kaydı ve genel kurul ciddi işlerdir. Arayüz kısa konuşur, ünlem kullanmaz, sizi acele ettirmez.',
    },
  ]
  return (
    <>
      <SayfaUstu>
        <Section className="pt-0 sm:pt-0" dar>
          <Reveal>
            <Baslik
              seviye="h1"
              eyebrow="Hakkımızda"
              baslik="İki derneğin ihtiyacından çıktı"
              metin="Akıllı Dernek, bin kişilik kongre düzenleyen bir meslek derneği ile sertifika programları yürüten bir akademi derneğinin yazılımını yıllarca ayrı ayrı yaparken öğrendiklerimizden doğdu. İkisinin de sorunu aynıydı: üye bir yerde, aidat başka yerde, site üçüncü, kongre dördüncü bir programda."
            />
          </Reveal>
          <Reveal delay={0.1}>
            <div className="prose-ad mt-8 text-[15px] leading-relaxed text-ink-2">
              <p>
                Bu iki derneği aynı platforma taşımak için sıfırdan, çok kiracılı bir sistem kurduk.
                İlk günden veritabanı seviyesinde izolasyon, roller, denetim kaydı ve şifreli
                sağlayıcı anahtarlarıyla. Çekirdeği önce onların gerçek verisiyle sınıyoruz; sonra
                pilot derneklere açıyoruz.
              </p>
              <p>
                Türkiye’de on binlerce dernek Excel, WhatsApp ve bir masaüstü programla yönetiliyor.
                Amacımız bunların yerine "bir tane daha program" koymak değil; derneğin bütün işini
                birbirini tanıyan modüllerle tek yerde toplamak ve yönetim kurulunun zamanını
                derneğin amacına bırakmak.
              </p>
            </div>
          </Reveal>
        </Section>
      </SayfaUstu>
      <Section className="bg-surface/60">
        <Reveal>
          <Baslik eyebrow="İlkeler" baslik="Nasıl çalışıyoruz" />
        </Reveal>
        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {ilkeler.map((i, n) => (
            <Reveal key={i.b} delay={n * 0.05}>
              <Kart className="h-full p-6">
                <p className="font-semibold text-ink">{i.b}</p>
                <p className="mt-2 text-sm leading-relaxed text-ink-2">{i.m}</p>
              </Kart>
            </Reveal>
          ))}
        </div>
      </Section>
      <SonCta
        baslik="Pilot programına katılın."
        metin="İlk derneklerle ayda bir görüşüyor, yol haritasını birlikte sıralıyoruz. Deneme hesabı açın; ihtiyacınızı panelden yazın."
      />
    </>
  )
}
